// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3Frhw","clinicsSelect":"TableHeading_clinicsSelect__3ybUH"};